/**
 * @generated SignedSource<<da89a0752454cb0d10a5ff4bcdfecb76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlinkHubspotDealInput = {
  projectId?: string | null;
  dealId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnlinkHubspotDealMutation$variables = {
  input: UnlinkHubspotDealInput;
};
export type UnlinkHubspotDealMutation$data = {
  readonly unlinkHubspotDeal: {
    readonly project: {
      readonly hubspotDeal: string | null;
    } | null;
  } | null;
};
export type UnlinkHubspotDealMutation = {
  variables: UnlinkHubspotDealMutation$variables;
  response: UnlinkHubspotDealMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "unlinkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "unlinkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4695a43e1b5c2acecd84b8ab0cd076eb",
    "id": null,
    "metadata": {},
    "name": "UnlinkHubspotDealMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkHubspotDealMutation(\n  $input: UnlinkHubspotDealInput!\n) {\n  unlinkHubspotDeal(input: $input) {\n    project {\n      hubspotDeal\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b842767bc2a184f498cfff7926545aa0";

export default node;
